<template>
  <span class="discount-node-label">
    <span :class="{ 'discount-node-set': hasValue }">
      <template v-if="hasObjectId">
        <strong :title="idTitle">ID: {{ node.object_id }}</strong>
        |
      </template>
      {{ node.title }}
      <strong>[{{ node.value }}]</strong>
      <strong v-if="hasObjectId">[{{ node.secondary_value }}]</strong>
    </span>
    <span
      v-if="hasObjectId && node.last_modification_date"
      title="Data ostatniej modyfikacji"
    >
      | {{ node.last_modification_date }}
    </span>
    <span
      v-for="note in node.notes || []"
      :key="note.pk"
      class="discount-node-note"
      title="Notatka"
    >
      <font-awesome-icon icon="note-sticky" />
      <span v-html="note.text"></span>
    </span>
    <template v-if="showActions && node.type === 'product'">
      <template v-if="node.has_quantity_discounts">
        <button
          type="button"
          class="btn btn-primary btn-sm"
          @click.stop="$emit('edit-quantity', node)"
        >
          Edytuj rabaty dla nakładów
        </button>
        <button
          v-if="canDelete"
          type="button"
          class="btn btn-warning btn-sm"
          @click.stop="$emit('delete-quantity', node)"
        >
          Usuń rabaty dla nakładów
        </button>
      </template>
      <button
        v-else-if="canAdd"
        type="button"
        class="btn btn-light btn-sm"
        @click.stop="$emit('add-quantity', node)"
      >
        Dodaj rabaty dla nakładów
      </button>
    </template>
  </span>
</template>

<script>
// The label of a node of the discount tree - what the list endpoint used to
// send as HTML in `text`: ID and dates for categories and products, the values
// highlighted when set, and the buttons of the quantity discounts of products.
export default {
  name: "DiscountNodeLabel",
  props: {
    node: { type: Object, required: true },
    showActions: { type: Boolean, default: false },
    canAdd: { type: Boolean, default: false },
    canDelete: { type: Boolean, default: false },
  },
  emits: ["add-quantity", "edit-quantity", "delete-quantity"],
  computed: {
    hasObjectId() {
      return this.node.type === "product" || this.node.type === "category";
    },
    hasValue() {
      return (
        Number(this.node.value) !== 0 || Number(this.node.secondary_value) !== 0
      );
    },
    idTitle() {
      return this.node.type === "product" ? "ID produktu" : "ID kategorii";
    },
  },
};
</script>

<style scoped>
.discount-node-set {
  color: orange;
}

.discount-node-note {
  margin-left: 6px;
  color: #8a6d3b;
  font-style: italic;
}

/* The note is short, so its paragraphs stay on the line of the label. */
.discount-node-note :deep(p) {
  display: inline;
  margin: 0;
}

.discount-node-label .btn {
  margin-left: 4px;
}
</style>
